import './style.scss';
import React from 'react';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import FAQCards from './cards';

const FAQTopicsCards = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="FAQTopicsCards" />;
  }

  const { heading, text, items: List } = props?.fields;
  const shouldRenderList = Array.isArray(List) && List.length > 0;

  if (!shouldRenderList) return null;
  const withHeaderData = true;

  const shouldRenderTitle = !!heading?.value;
  const shouldRenderDescription = !!text?.value;

  return (
    <div
      className={clsx(
        'faq-header',
        withHeaderData && 'withHeaderData',
        'add-margins',
        props?.params?.Styles
      )}
    >
      <div className="wrap-header-and-content">
        <div className="ellipse mobile">
          <img border="none" src={'/-/media/Project/FAB2/shared/images/ellispse_green_m.svg'} />
        </div>
        <div className="ellipse desktop">
          <img border="none" src={'/-/media/Project/FAB2/shared/images/ellispse_green.svg'} />
        </div>
        <div className="content">
          <div className="faq-header-auto">
            {shouldRenderTitle && (
              <div className="faq-header-title">
                <Text field={heading} />
              </div>
            )}
            {shouldRenderDescription && (
              <div className="faq-header-description">
                <RichText field={text} />
              </div>
            )}
          </div>

          <div className="faq-listing">
            <FAQCards List={List} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(FAQTopicsCards);
